import gql from 'graphql-tag';

export const MARK_AS_READ = gql`
  mutation markAsRead($input: UpdateNotificationsInput!) {
    updateNotifications(input: $input) {
      id
      read
    }
  }
`;

export const markAsReadMock = {
  updateNotifications: [{ id: 2, read: true }],
};
